import http from './http';

export interface ModuleAccessItem {
  key: string;
  label: string;
  /** Effective value for the signed-in account (drives navigation gating). */
  enabled: boolean;
  /** Platform default the settings switches control (owner view). */
  default_enabled?: boolean;
  required: boolean;
}
export interface ModuleAccessResponse { is_owner: boolean; modules: ModuleAccessItem[]; }
export interface UserModuleAccess {
  id: string;
  username: string;
  email: string;
  chat_uploads_enabled: boolean;
}

export const moduleAccessApi = {
  get: () => http.get<ModuleAccessResponse>('/module-access').then(r => r.data),
  set: (key: string, enabled: boolean) =>
    http.put<ModuleAccessResponse>(`/module-access/${key}`, { enabled }).then(r => r.data),
  users: () => http.get<UserModuleAccess[]>('/module-access/users').then(r => r.data),
  setUser: (userId: string, key: string, enabled: boolean) =>
    http.put<UserModuleAccess>(`/module-access/users/${userId}/${key}`, { enabled }).then(r => r.data),
};
